import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  NewsletterDominoPageStyled,
  TitleStyled,
  BackButtonStyled,
  BackImageStyled,
} from './NewsletterDomino.styles';
import backIcon from 'assets/images/backIcon.svg';
import { routes } from 'router/routes';
import { PrivateLayout } from 'components/layout';
import { useMedia } from 'hooks';
import { useTheme } from 'styled-components';

type NewsletterDominoPropsType = {};

const NewsletterDomino = (props: NewsletterDominoPropsType) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user.newsletters',
  });
  const { isLargerThan767 } = useMedia();
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <PrivateLayout>
      <NewsletterDominoPageStyled
        isLargerThan767={isLargerThan767}
        primaryColor={theme.colors.primary}
      >
        <BackButtonStyled
          id="ButtonBack"
          onClick={() => navigate(`/${routes.home.path}`)}
        >
          <BackImageStyled src={backIcon} />
          {t('return')}
        </BackButtonStyled>
        <TitleStyled>
          {t('subscribeToNewsletter', { product: 'Domino' })}
        </TitleStyled>
        // @TODO: place here the iframe with the form
      </NewsletterDominoPageStyled>
    </PrivateLayout>
  );
};

export default NewsletterDomino;
